import { AUTH_SERVICES, env, F18_SERVICES } from '../configs/Config'
import { apiCMSWithToken } from './axios'

export async function login(body) {
  const response = await apiCMSWithToken.post(AUTH_SERVICES.login, body)
  return response
}

export async function logout() {
  const response = await apiCMSWithToken.post(AUTH_SERVICES.logout)
  return response
}

export async function refreshToken(body) {
  const response = await apiCMSWithToken.post(AUTH_SERVICES.refreshToken, body)
  return response
}

// export async function roleSearch({
//   name = '',
//   type = '',
//   status = '',
//   page = 1,
//   pageSize = 10
// }) {
//   try {
//     const params = new URLSearchParams()
//     params.append('name', name)
//     params.append('type', type)
//     params.append('status', status)
//     params.append('page', page)
//     params.append('pageSize', pageSize)

//     const response = await apiCMSWithToken.get(
//       `${AUTH_SERVICES.permission}?${params.toString()}`
//     )

//     return response
//   } catch (error) {
//     console.error('Error in issueSearch:', error)
//     throw error
//   }
// }

export async function roleSearch(filters = {}) {
  try {
    const params = new URLSearchParams(filters).toString()
    const response = await apiCMSWithToken.get(
      `${AUTH_SERVICES.permission}?${params}`
    )
    return response
  } catch (error) {
    console.error('Error in postSearch:', error)
    throw error
  }
}

export async function departmentSearch({
  name = '',
  type = '',
  department_id = '',
  page = 1,
  pageSize = 10
}) {
  try {
    const params = new URLSearchParams()
    params.append('name', name)
    params.append('type', type)
    params.append('department_id', department_id)
    params.append('page', page)
    params.append('pageSize', pageSize)

    const response = await apiCMSWithToken.get(
      `${F18_SERVICES.department}?${params.toString()}`
    )

    return response
  } catch (error) {
    console.error('Error in issueSearch:', error)
    throw error
  }
}

export async function departmentCreate(body) {
  const response = await apiCMSWithToken.post(F18_SERVICES.department, body)
  return response
}

export async function departmentDetail(id) {
  try {
    const response = await apiCMSWithToken.get(
      `${F18_SERVICES.department}/${id}`
    )

    return response
  } catch (error) {
    console.error('Error in issueSearch:', error)
    throw error
  }
}

export async function departmentUpdate(body, id) {
  try {
    const response = await apiCMSWithToken.put(
      `${F18_SERVICES.department}/${id}`,
      body
    )
    return response

    return response
  } catch (error) {
    console.error('Error in issueSearch:', error)
    throw error
  }
}

export async function departmentDelete(id) {
  try {
    const response = await apiCMSWithToken.delete(
      `${F18_SERVICES.department}/${id}`
    )

    return response
  } catch (error) {
    console.error('Error in issueSearch:', error)
    throw error
  }
}

export async function roleCreate(body) {
  const response = await apiCMSWithToken.post(F18_SERVICES.permission, body)
  return response
}

export async function roleDetail(id) {
  try {
    const response = await apiCMSWithToken.get(
      `${F18_SERVICES.permission}/${id}`
    )

    return response
  } catch (error) {
    console.error('Error in issueSearch:', error)
    throw error
  }
}
export async function roleUpdate(body, id) {
  try {
    const response = await apiCMSWithToken.put(
      `${F18_SERVICES.permission}/${id}`,
      body
    )
    return response
  } catch (error) {
    console.error('Error in issueSearch:', error)
    throw error
  }
}

export async function updateStatus(status = '', id) {
  const body = {
    status: status
  }
  try {
    const response = await apiCMSWithToken.patch(
      `${F18_SERVICES.permission}/${id}/update-status`,
      body
    )
    return response
  } catch (error) {
    console.error('Error in issueSearch:', error)
    throw error
  }
}

export async function userSearch({
  search = '',
  role = '',
  department = '',
  status = '',
  type_role = '',
  // user_role = '',
  type = '',
  page = 1,
  pageSize = 10
}) {
  try {
    const params = new URLSearchParams()
    params.append('search', search)
    params.append('role', role)
    params.append('department', department)
    params.append('status', status)
    params.append('type_role', type_role)
    // params.append('user_role', user_role)
    params.append('type', type)
    params.append('page', page)
    params.append('pageSize', pageSize)

    const response = await apiCMSWithToken.get(
      `${F18_SERVICES.user}?${params.toString()}`
    )

    return response
  } catch (error) {
    console.error('Error in issueSearch:', error)
    throw error
  }
}

export async function userDetail(id) {
  try {
    const response = await apiCMSWithToken.get(`${F18_SERVICES.user}/${id}`)

    return response
  } catch (error) {
    console.error('Error in issueSearch:', error)
    throw error
  }
}

export async function userCreate(body) {
  const response = await apiCMSWithToken.post(F18_SERVICES.user, body)
  return response
}
export async function userUpdate(body, id) {
  const response = await apiCMSWithToken.put(`${F18_SERVICES.user}/${id}`, body)
  return response
}

export async function pakagesSearch() {
  const body = {
    page: 1,
    pageSize: 1000
  }
  try {
    const response = await apiCMSWithToken.get(`${F18_SERVICES.pakages}`, {
      params: body
    })

    return response
  } catch (error) {
    console.error('Error in issueSearch:', error)
    throw error
  }
}

export async function updateStatusUser(status = '', id, type = '') {
  const body = {
    status: status,
    id
  }
  if (type) {
    body.type = type
  }
  try {
    const response = await apiCMSWithToken.put(
      `${F18_SERVICES.user}/${id}/update-status`,
      body
    )
    return response
  } catch (error) {
    console.error('Error in issueSearch:', error)
    throw error
  }
}

export async function changePassword(body, id) {
  const response = await apiCMSWithToken.put(
    `user/${id}${F18_SERVICES.changePassword}`,
    body
  )
  return response
}

// Chung

export async function getSystemManager(p = {}) {
  try {
    const params = new URLSearchParams({ ...p })
    const response = await apiCMSWithToken.get(
      `/report/cms-report-center?${params.toString()}`
    )
    return response
  } catch (error) {
    console.error('Error in postSearch:', error)
    throw error
  }
}

export async function getCmsReportShowPhone(p = {}) {
  try {
    const params = new URLSearchParams({ ...p })
    const response = await apiCMSWithToken.get(
      `/report/cms-report-show-phone?${params.toString()}`
    )
    return response
  } catch (error) {
    console.error('Error in getCmsReportShowPhone:', error)
    throw error
  }
}

export async function exportExcelSystemManager(p = {}) {
  try {
    const params = new URLSearchParams({ ...p })
    const response = await apiCMSWithToken.get(
      `report/export-file?${params.toString()}`
    )
    return response
  } catch (error) {
    console.error('Error in postSearch:', error)
    throw error
  }
}

export async function getNotificationManager(p = {}) {
  try {
    const params = new URLSearchParams({ ...p })
    const response = await apiCMSWithToken.get(
      `${F18_SERVICES.notification}?${params.toString()}`
    )
    return response
  } catch (error) {
    console.error('Error in postSearch:', error)
    throw error
  }
}

export async function notificationManagerAdd(body) {
  const response = await apiCMSWithToken.post(
    `${F18_SERVICES.notification}`,
    body
  )
  return response
}

export async function notificationManagerUpdate(body, id) {
  const response = await apiCMSWithToken.put(
    `${F18_SERVICES.notification}/${id}`,
    body
  )
  return response
}

export async function notificationDetail(id) {
  try {
    const response = await apiCMSWithToken.get(
      `${F18_SERVICES.notification}/${id}`
    )

    return response
  } catch (error) {
    console.error('Error in issueSearch:', error)
    throw error
  }
}
export async function notificationStatus(status, id) {
  const body = {
    status: status
  }
  try {
    const response = await apiCMSWithToken.put(
      `${F18_SERVICES.notification}/status/${id}`,
      body
    )

    return response
  } catch (error) {
    console.error('Error in issueSearch:', error)
    throw error
  }
}

export async function addMoney(body) {
  const response = await apiCMSWithToken.post(`${F18_SERVICES.addMoney}`, body)
  return response
}

export async function deleteRole(id) {
  try {
    const response = await apiCMSWithToken.delete(
      `${F18_SERVICES.permission}/delete-permission?id=${id}`
    )
    return response
  } catch (error) {
    console.error('Error in issueSearch:', error)
    throw error
  }
}

export async function departmentAll({ page = 1, pageSize = 10 }) {
  try {
    const params = new URLSearchParams()
    params.append('page', page)
    params.append('pageSize', pageSize)

    const response = await apiCMSWithToken.get(
      `${F18_SERVICES.department}/list-all-department?${params.toString()}`
    )

    return response
  } catch (error) {
    console.error('Error in issueSearch:', error)
    throw error
  }
}

export async function permissionByDepartment(id) {
  if (id == '') {
    try {
      const params = new URLSearchParams()
      params.append('page', 1)
      params.append('pageSize', 1000)
      const response = await apiCMSWithToken.get(
        `${AUTH_SERVICES.permission}?${params}`
      )
      return response
    } catch (error) {
      console.error('Error in postSearch:', error)
      throw error
    }
  } else {
    try {
      const response = await apiCMSWithToken.get(
        `${AUTH_SERVICES.permission}/list-by-department?department=${id}`
      )
      return response
    } catch (error) {
      console.error('Error in postSearch:', error)
      throw error
    }
  }
}

export default {
  login,
  logout,
  refreshToken,
  roleSearch,
  departmentSearch,
  roleCreate,
  roleDetail,
  updateStatus,
  userSearch,
  userDetail,
  userCreate,
  userUpdate,
  departmentCreate,
  departmentDetail,
  departmentUpdate,
  departmentDelete,
  pakagesSearch,
  updateStatusUser,
  changePassword,
  getSystemManager,
  getCmsReportShowPhone,
  exportExcelSystemManager,
  getNotificationManager,
  notificationManagerAdd,
  notificationManagerUpdate,
  notificationDetail,
  notificationStatus,
  addMoney,
  deleteRole,
  departmentAll,
  permissionByDepartment
}
